import axios from "axios";

const baseURL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.roadsense.tech"
    : "https://api.roadsense.tech");

export default axios.create({
  baseURL: baseURL,
});

export const privateInstance = axios.create({
  baseURL: baseURL,
  headers: { "Content-type": "application/json" },
  withCredentials: true,
});
